import React from "react";
import { Link } from "react-router-dom";

import copy from "../../data/copy.js";

import CabinetProject from "./CabinetProject";
import CabinetMethod from "./CabinetMethod";
import CabinetResources from "./CabinetResources";
import CabinetHistory from "./CabinetHistory";
import CabinetLogin from "./CabinetLogin";
import Loading from "../../components/Loading";

class CabinetInfo extends React.Component {
  constructor(props) {
    super(props);
    this.state = { documents: [] };
  }

  fetchDocuments() {
    fetch("/api/documents")
      .then(response => response.json())
      .then(json => {
        let docs;
        if (json["land"].length) {
          this.setState({ documents: json, hasDocs: true });
        } else {
          console.log(json);
          alert(
            "Something is wrong with the server response. See console for details."
          );
        }
        //this.setState({ docs, hasDocs: true });
      })
      .catch(e => {
        console.log(e);
      });
  }

  renderExploreButton() {
    if (!this.props.isMobile) {
      return (
        <div className="top-action action not-on-mobile">
          <button onClick={() => (window.location.href = "/index")}>
            <svg x="0px" y="0px" width="28px" height="28px" viewBox="0 0 40 40">
              <line
                strokeLinejoin="round"
                x1="14.102"
                y1="29.93"
                x2="25.781"
                y2="33.123"
              />
              <polyline
                strokeLinejoin="round"
                points="23.734,11.443 25.781,33.123
                38.659,30.479 32.002,10.423 23.734,11.443 "
              />
              <path
                strokeLinejoin="round"
                d="M23.753,6.609
                c0-2.105-1.706-3.811-3.811-3.811S16.13,4.504,16.13,6.609c0,0.729,0.208,1.407,0.563,1.986h-0.005l3.254,5.605l3.253-5.605H23.19
                C23.545,8.016,23.753,7.338,23.753,6.609z"
              />
              <polyline
                strokeLinejoin="round"
                points="17,9.134 15.15,8.499 6.647,12.605
                1.842,32.774 14.102,29.93 15.15,8.499 "
              />
              <line
                strokeLinejoin="round"
                x1="21.906"
                y1="10.816"
                x2="23.734"
                y2="11.443"
              />
            </svg>
            <div className="label">
              {copy[this.props.languageId].cabinet.terms.investigate} &rarr;
            </div>
          </button>
        </div>
      );
    }
  }

  renderToggleMenu() {
    let classes = "side-menu-burg side-menu-file-cabinet";
    classes += this.props.sidebarOpen ? " is-active" : "";
    return (
      <button className={classes} onClick={this.props.toggleSidebar}>
        <span />
      </button>
    );
  }

  renderHeader() {
    return (
      <div className="cabinet-header">
        <div className="header-title">
          <Link to="/">
            <p>{copy[this.props.languageId].cabinet.terms.title}</p>
            <p>{copy[this.props.languageId].cabinet.terms.untertitle}</p>
          </Link>
        </div>
      </div>
    );
  }

  renderCabinetPage(pageName, lang) {
    switch (pageName) {
      case "about":
        return <CabinetProject languageId={lang} />;
      case "methodology":
        return <CabinetMethod languageId={lang} />;
      case "history":
        return <CabinetHistory languageId={lang} />;
      case "resources": {
        if (!this.state.documents || this.state.documents.length == 0) {
          this.fetchDocuments();
          return <Loading languageId={lang} />;
        } else {
          return (
            <CabinetResources docs={this.state.documents} languageId={lang} />
          );
        }
      }
      case "login":
        return <CabinetLogin languageId={lang} />;
      default:
        return <div>Not found</div>;
    }
  }

  render() {
    return (
      <div className="cabinet-wrapper-files cabinet-files">
        {this.renderCabinetPage(
          this.props.match.params.pageName,
          this.props.languageId
        )}
        {this.renderExploreButton()}
        {this.renderToggleMenu()}
        {this.renderHeader()}
      </div>
    );
  }
}

export default CabinetInfo;



// WEBPACK FOOTER //
// ./application/frontend/src/containers/cabinet/CabinetInfo.jsx